import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import * as apiCompany from "../../../../api/apiCompany"
import * as Auth from "../../../Login/Auth"
import { Pagination } from '../../Res/Pagination';
import { CompanyAdd } from '../../Content/Company/CompanyAdd';
import { CompanyEdit } from '../../Content/Company/CompanyEdit';
import { ContentBox } from '../../Content/ContentBox';
import { EditButton, ListButton } from '../../Res/BaseButton';

export function AdminCompanyList() {
  const [userInfo] = useState(Auth.getUserInfo())
  const [disableCount, setDisableCount] = useState(0)
  const [enableCount, setEnableCount] = useState(0)
  const [isEdit, setisEdit] = useState(false)
  const [company, setCompany] = useState()
  const [change, setChange] = useState(false)


console.log(userInfo)
  var title = '公司列表'
  var title_tools = ''
  var content = <CompanyListBox id={userInfo.accountId} setDisableCount={setDisableCount} setEnableCount={setEnableCount} toEdit={toEdit} ch={change} />

  function toEdit(status, c) {
    setisEdit(status)
    setCompany(c)
    if (!status) {
      setChange(!change)
    }
  }
  function toCompanyAdd() {

    //window.location.replace("/CompanyAdd");
  }

  return (
    <>
      <ContentBox title={title} enableCount={enableCount} disableCount={disableCount} disableText={"停權"} title_tools={title_tools} content={content} hasDrawer={true} />

    </>
  )
  /* {isEdit?<CompanyEdit editCancel={toEdit} company={company} /> :
      <CompanyAdd />
    }
    <section className="content">
      <div className="box box-default">
        <div className="box-header with-border">
        
          <div className="col-sm-3">
            <h3 className="box-title">公司列表</h3>
          </div>
          <div className="col-sm-3">
            啟用 <span className="badge bg-green">{enableCount}</span>
          </div>

          <div className="col-sm-3">
            停用 <span className="badge bg-red">{disableCount}</span>
          </div>
          
          <div className="col-sm-2">
            <button type="button" className="btn btn-block btn-info btn-sm" onClick={toCompanyAdd}><i className="fa fa-plus"></i> 新增</button>
          </div>
           

           <div className="box-tools pull-right">
           <button type="button" className="btn btn-box-tool" data-widget="collapse"><i className="fa fa-minus"></i></button>
         </div>
       </div>

       <div className="box-header">
         <CompanyListBox id={id} setDisableCount={setDisableCount} setEnableCount={setEnableCount} toEdit={toEdit} ch={change} />          
       </div>
     </div>
       {isEdit?<CompanyEdit editCancel={toEdit} company={company} /> :
         <CompanyAdd />
       }
   </section>
   */
}


function CompanyListBox({ id, setDisableCount, setEnableCount, toEdit, ch }) {
  const [companyList, setCompanyList] = useState({})
  const [page, setPage] = useState(1)
  const [limit] = useState(10)
  const [change, setChange] = useState(ch)
  //const [count, setCount] = useState(0)

  function getCompanyList() {
    //console.log("getManagerList")
    //console.log("page : "+ page)
    var start = (page - 1) * limit;
    apiCompany.getCompanyList({ /* start, limit,*/
      applyId: id,
      success: (obj) => {
        setCompanyList(obj)
        console.log(obj)
        setDisableCount(obj.disableCount)
        setEnableCount(obj.enableCount)
      },
      failure: (err) => {
        console.log(err)
        //window.location.replace("/AdminManagerList");
      }
    })
  }


  function sPage(p) {
    if (p !== page) {
      getCompanyList()
      setPage(p)
    }
  }


  useEffect(() => {
    if (companyList.status === undefined)
      getCompanyList()
  }, [])

  useEffect(() => {
    if (change !== ch) {
      console.log("change")
      setChange(ch)
      getCompanyList()
    }
  })


  if (companyList.status === undefined) {
    return (<></>)
  } else {
    //console.log(managerList)
    return (
      <>
        <div id="editable_wrapper" className="form-inline dt-bootstrap">
          <div className="row">
            <div className="col-sm-12">
              <table className="table table-striped table-bordered table-hover  dataTable">
                <thead>
                  <tr role="row">
                    <th className="text-center sorting col-sm-3">名稱</th>
                    <th className="text-center sorting col-sm-3">啟用員工</th>
                    <th className="text-center sorting col-sm-3">停用員工</th>
                  <th className="text-center sorting col-sm-3">狀態</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    companyList.list.map((manager) => (
                      <CompanyBox key={manager.companyId} manager={manager} toEdit={toEdit} />
                    ))
                  }

                </tbody>
              </table>
            </div>
          </div>

        </div>
        {
          companyList.count === 0 ? <></> : <Pagination p={page} l={limit} c={companyList.count} sp={sPage} />
        }
      </>
    )
  }

}

function CompanyBox({ manager, toEdit }) {
  const [company, setAccount] = useState(manager)
  if (company !== manager) {
    setAccount(manager)
  }

  function toDepartment() {
    toEdit(false);
    window.location.assign("/AdminDepartmentList/" + company.companyId);
  }

  var status = "<></>";
  if (company.isDisable === 1) {
    status = <span className="text-danger">停用</span>
  } else {
    status = <span className="text-info">啟用</span>
  }

  function edit() {
    toEdit(true, company)
  }

  return (
    <tr>
    <td className="text-center"><a href="#A" onClick={e=>toDepartment()}>{company.companyName}</a></td>
    <td className="text-center">-</td>
    <td className="text-center">-</td>
    <td className="text-center">{status}</td>
    {/**
      <td style={{ verticalAlign: "middle" }}><div>{company.companyName}</div></td>
      <td style={{ verticalAlign: "middle" }}>{company.texIdNumber}</td>
      <td style={{ verticalAlign: "middle" }}>{company.businessArea}</td>
      <td style={{ verticalAlign: "middle" }}></td>
      <td style={{ verticalAlign: "middle" }}>{status}</td>
      <td style={{ verticalAlign: "middle" }}>{company.note}</td>
      <td style={{ verticalAlign: "middle" }}>
        <div className="btn-group">
          <EditButton action={edit} />
          <ListButton name={"部門"} action={toDepartment} />
        </div>
      </td>
     */}
    </tr>
  )
}